// extracted by mini-css-extract-plugin
module.exports = {"volume":"VolumeController_volume__1JcTZ","volumeBlock":"VolumeController_volumeBlock__18QwQ"};